import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeDTO  {
    _originalTypeClassName = "zERP.BO.EmployeeDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeDTO.translate = translateService;
}
this.Id = null;
this.Code = null;
this.FirstName = null;
this.LastName = null;
this.FatherName = null;
this.Fullname = null;
this.DateOfBirth = null;
this.PhoneNumber = null;
this.Email = null;
this.ExternalID = null;
this.IsActive = false;
this.ContractTemplate = null;
this.SocialSecurityNumber = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
FirstName:any;
LastName:any;
FatherName:any;
Fullname:any;
DateOfBirth:any;
PhoneNumber:any;
Email:any;
ExternalID:any;
IsActive:any;
ContractTemplate:any;
SocialSecurityNumber:any;

static Assign(e: any): any{let dtoE = new Domain.EmployeeDTO();
dtoE.Id = e?.Id;
dtoE.Fullname = e?.Fullname;
dtoE.Code = e?.Code;
return dtoE;
}
static GetFullname($this: any): any{return $this?.LastName + " " + $this?.FirstName;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}